var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 23.5C14 24.05 13.55 24.5 13 24.5H1C0.45 24.5 0 24.05 0 23.5C0 19.63 3.13 16.5 7 16.5C10.87 16.5 14 19.63 14 23.5ZM11 10.5C11 8.29 9.21 6.5 7 6.5C4.79 6.5 3 8.29 3 10.5C3 12.71 4.79 14.5 7 14.5C9.21 14.5 11 12.71 11 10.5ZM19 0.5H9C6.31 0.5 4.13 2.64 4.02 5.3C4.9 4.79 5.91 4.5 7 4.5C9.74 4.5 12.04 6.34 12.76 8.85L15 11.09L18.59 7.5H17C16.45 7.5 16 7.05 16 6.5C16 5.95 16.45 5.5 17 5.5H20C21.1 5.5 22 6.4 22 7.5V10.5C22 11.05 21.55 11.5 21 11.5C20.45 11.5 20 11.05 20 10.5V8.91L16.41 12.5C15.63 13.28 14.36 13.28 13.58 12.5L12.86 11.78C12.86 11.78 12.86 11.79 12.86 11.8C12.55 13.21 11.74 14.43 10.63 15.27C12.2 15.96 13.53 17.09 14.48 18.5H19.01C21.77 18.5 24.01 16.26 24.01 13.5V5.5C24.01 2.74 21.77 0.5 19.01 0.5H19Z",
    fill: "#305F32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPip);
export default __webpack_public_path__ + "static/media/pip.808d215e30cb7a70097425840eb23b7d.svg";
export { ForwardRef as ReactComponent };